<template>
  <v-dialog
    v-if="selected.length > 1"
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    scrollable
    max-width="500px"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>MERGE {{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-title
        >Pilih salah satu {{ title }} yang dituju di bawah ini:</v-card-title
      >
      <v-divider></v-divider>
      <v-card-text style="height: 1000px">
        <v-radio-group v-model="mergeId" column>
          <v-layout
            v-for="(item, i) in selected"
            :key="i"
            class="my-1"
            align-center
          >
            <v-radio class="pa-0 ma-0" :value="item[primary_key]"> </v-radio>
            <slot name="item-detail" :item="item"> </slot>
          </v-layout>
        </v-radio-group>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="cancelMerge">BATAL</v-btn>
        <v-btn
          color="primary"
          :dark="!!mergeId"
          :disabled="!mergeId"
          @click="submitMerge"
          >MERGE</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "pg-form-merge",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: new Array()
    },
    title: {
      type: String,
      default: ""
    },
    primary_key: {
      type: String,
      default: ""
    },
    action: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      mergeId: "",
      delay: 1000
    };
  },
  computed: {
    ...mapState(["status"])
  },
  methods: {
    cancelMerge() {
      this.mergeId = "";
      this.$emit("cancel");
    },
    submitMerge() {
      let mergeData = {
        mergeId: this.mergeId,
        mergeSource: this.selected
      };
      this.$store
        .dispatch(this.action, mergeData)
        .then(() => {
          this.mergeId = "";
          this.$emit("merged", this.delay);
        })
        .catch();
    }
  }
};
</script>
